import * as React from "react";

type RowAlertProps = {
    type: string, // string like "danger", "info", "success"
    children: React.Node,
};

const RowAlert = ({ type, children }: RowAlertProps) => (
    <div className="row">
        <div className="col-sm-12">
            <div className={"alert alert-" + type}>{children}</div>
        </div>
    </div>
);
export default RowAlert;
